<template>
    <div>
        <Header/>
        <!--banner-->
        <div class="index_banner">
            <div class="swiper-container">
                <div class="swiper-wrapper">
                    <div class="swiper-slide b_slide1">
                        <a href="#">
                            <div class="img"
                                 style="background-image:url(https://cdn.gda.top/image_after_2019_06/2710/banner.jpg); "></div>
                            <div class="word">
                                <p class="txt1">{{$t('company_culture_introduction_2_descripte')}}</p>
                            </div>
                        </a>
                    </div>
                    <div class="swiper-slide b_slide1 b_slide2">
                        <a href="#">
                            <div class="img"
                                 style="background-image:url(https://cdn.gda.top/image_after_2019_06/2618/banner1.jpg); "></div>
                            <div class="word">
                                <p class="txt1">{{$t('company_culture_introduction_2_descripte')}}</p>
                            </div>
                        </a>
                    </div>
                    <div class="swiper-slide b_slide1 b_slide2">
                        <a href="#">
                            <div class="img"
                                 style="background-image:url(https://cdn.gda.top/image_after_2019_06/2621/banner2.jpg); "></div>
                            <div class="word">
                                <p class="txt1">{{$t('company_culture_introduction_2_descripte')}}</p>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="swiper-pagination"></div>
            </div>

        </div>
        <!--内容部分-->

        <div class="index_two">
            <div class="index_title"><i>-</i> {{$t('business_introductions')}} <i>-</i><span class="english">BUSINESS INTRODUCTION</span></div>

            <div class="inlist">
                <ul class="after">
                    <li>

                        <a href="/agency_business">

                            <h2>{{$t("commercial_bank")}}</h2>
                            <div class="word">
                                {{$t("commercial_bank_introduction_1")}}<br>
                                {{$t("commercial_bank_introduction_2")}}
                            </div>
                            <span>{{$t("learn_more")}}<i></i></span></a>

                    </li>
                    <li>

                        <a href="/agency_business">

                            <h2>{{$t("fund_company")}}</h2>
                            <div class="word">
                                {{$t("fund_company_introduction_1")}}<br>
                                {{$t("fund_company_introduction_2")}}
                            </div>
                            <span>{{$t("learn_more")}}<i></i></span></a>

                    </li>
                    <li>

                        <a href="/agency_business">

                            <h2>{{$t("insurance_company")}}</h2>
                            <div class="word">
                                {{$t("insurance_company_introduction_1")}}<br>
                                {{$t("insurance_company_introduction_2")}}<br>
                                {{$t("insurance_company_introduction_3")}}
                            </div>
                            <span>{{$t("learn_more")}}<i></i></span></a>

                    </li>
                    <li>

                        <a href="/agency_business">


                            <h2>{{$t("private_placement_customers")}}</h2>
                            <div class="word">
                                {{$t("private_placement_customers_introduction_1")}}<br>
                                {{$t("private_placement_customers_introduction_2")}}
                            </div>
                            <span>{{$t("learn_more")}}<i></i></span></a>

                    </li>
                </ul>
            </div>
        </div>
        <div class="index_one">
            <ul class="after">

                <li><a :href="www_url" target="_blank"><img
                        src="https://cdn.gda.top/image_after_2019_06/2922/W020181022515612598117.png"/>
                    <p>{{$t("i_want_to_sign_up")}}</p></a></li>

                <li><a href="#"><img
                        src="https://cdn.gda.top/image_after_2019_06/2923/W020181022516507279710.png"/>
                    <p>{{$t("business_outlets")}}</p></a></li>

                <li><a href="/download_app"><img
                        src="https://cdn.gda.top/image_after_2019_06/2924/W020181022516974048224.png"/>
                        <p>{{$t("download_software")}}</p></a></li>

                <li><a href="/news"><img
                        src="https://cdn.gda.top/image_after_2019_06/2925/W020181022591763686405.png"/>
                    <p>{{$t("information_centre")}}</p></a></li>

                <li>
                  <a :href="signUrl">
                    <img src="https://cdn.gda.top/image_after_2019_06/2926/W020181022594178564886.png"/>
                    <p>{{$t("counter_appointment")}}</p>
                  </a>
                </li>

            </ul>
        </div>

        <div class="index_seven">
            <div class="index_title"><i>-</i> {{$t("about_us")}} <i>-</i><span class="english">ABOUT US</span></div>

            <div class="word">
                <p style="text-indent: 2em;">
                    {{$t("home_about_us_text_one")}}
                </p>
                <p style="text-indent: 2em;">
                    {{$t("home_about_us_text_two")}}
                </p>
                <p style="text-indent: 2em;">
                    {{$t("home_about_us_text_three")}}
                </p>
            </div>
        </div>
        <Footer/>
    </div>

</template>
<script>
    import Vue from 'vue'
    import Footer from "../components/Footer";
    import Header from "../components/Header";

    export default {
        components: {Header, Footer},
        data() {
          return {
              languageData:[
                  {
                      label:'zh',
                      name:'简体中文'
                  },
                  {
                      label:'en',
                      name:'English'
                  },
                  {
                      label:'ru',
                      name:'русский'
                  },
                  {
                      label:'jp',
                      name:'日本語'
                  },
                  {
                      label:'kr',
                      name:'한국어'
                  }
              ],
              signUrl: '',
              www_url: "",
              ase_url: "",
          }
      },
        methods: {
            // 业务公告部分 小卡片内容不一致 这里处理一下让小卡片高度一致
            resizeCardHeight(){
                let m_height = $(".index_two .inlist li").eq(0).find(".word").height();
                $(".index_two .inlist li").each(function () {
                    let i = $(this).index();
                    m_height = m_height < $(".index_two .inlist li").eq(i + 1).find(".word").height() ? $(".index_two .inlist li").eq(i + 1).find(".word").height() : m_height
                })
                $(".index_two .inlist li .word").height(m_height);
            }
        },
        mounted() {
            this.www_url = this.loginUrl = Vue.getValueByKey('www_path') + '?lang=' + this.currentLang;
            this.signUrl = Vue.getValueByKey('cas_path')+'/sign_up?service=' + window.location.href.split('?')[0] + '&lang=' + this.currentLang;
            this.ase_url = Vue.getValueByKey('ase_path') + '?lang=' + this.currentLang;
            //  banner背景图的轮播
            let swiper1 = new Swiper('.index_banner .swiper-container', {
                loop: true,
                speed: 1000,
                autoplay:5000,
                pagination: '.index_banner .swiper-pagination',
                paginationClickable: true,
                autoplayDisableOnInteraction: false,
            });
            // 中间部分 指数的轮播效果
            let swiper2 = new Swiper('.index_three .swiper-container', {
                loop: true,
                speed: 1000,
                autoplay: 5000,
                slidesPerView: 4,
                autoplayDisableOnInteraction: false,
                nextButton: '.index_three .swiper-button-next',
                prevButton: '.index_three .swiper-button-prev',
            });
        },

    }
</script>
<style lang="scss" scoped>
@import url('../css/2020_swiper.min.css');
@import url('../css/public_20200313v4.css');
@import url('../css/index.css');
@import url('../css/public_footer.css');
@import url('../css/zxStyle.css');
@import url('../css/zxPubliceStyle.css');
@import url('../css/shzr_zr2020.css');
</style>
<style scoped>
    .fixce a img {
        display: block;
        width: auto !important;
        margin: 0 auto;
    }

    .fixce li .leftlist {
        width: 190px;
        right: -190px;
    }

    .fixce li .leftlist a {
        display: inline-block;
        width: 60px;
    }

    .fixce li:hover .leftlist {
        right: 64px;
    }
    .index_one p{
        display: block;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        width: 100%;
    }
</style>
